import type React from 'react';
import { useEffect } from 'react';

export const OauthClose: React.FC = () => {
  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const provider = urlParams.get('provider'); // e.g., 'google' or 'microsoft'

      if (window.opener && provider) {
        const message = {
          type: 'calendar-connected',
          provider,
          success: true,
        };

        // Prefer the opener's origin (TeamHub when hosted). Fall back to '*'
        // when cross-origin access to opener.location is blocked.
        let targetOrigin = window.location.origin;
        try {
          if (window.opener.location?.origin) {
            targetOrigin = window.opener.location.origin;
          }
        } catch {
          targetOrigin = '*';
        }

        window.opener.postMessage(message, targetOrigin);

        // Auto-close the popup shortly after notifying the opener
        setTimeout(() => {
          window.close();
        }, 200);
      }
    } catch (error) {
      // Swallow errors; this page is only a small utility popup
      // and we don't want failures here to break the main app.
      console.error('OAuth close handler failed', error);
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      }}
    >
      <p>You may now close this window.</p>
    </div>
  );
};
